// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"94043b07","436":"4df618fb","549":"4df618fb","769":"bae4bcfa","801":"da707a85","984":"425b9345"}[chunkId] + ".chunk.css";
};